<template>
  <div>
    <page-header>
      <el-button type="primary" @click="addImageCategory">新增分类</el-button>
    </page-header>
    <el-table :data="list" border>
      <el-table-column prop="name" label="名称"/>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button icon="el-icon-delete" type="text" @click="deleteImageCategory(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from "@/utils/api";
import PageHeader from "@/components/PageHeader";

export default {
  name: "ImageCategories",
  components: {PageHeader},
  data() {
    return {
      list: []
    }
  },
  methods: {
    getImageCategoryList() {
      api.image_getImageCategoryList({}).then(res => {
        this.list = res.data.data;
      });
    },
    addImageCategory() {
      this.$prompt('请输入分类名称', {
        title: '新增分类'
      }).then(res => {
        if (res.action !== 'confirm') {
          return;
        }
        if (!res.value) {
          this.$message.error('名称不能为空');
          return;
        }
        api.image_addImageCategory({
          name: res.value
        }).then(res => {
          if (res.data.code !== '000') {
            this.$message.error(res.data.message);
            return;
          }
          this.$message.success('添加成功');
          this.getImageCategoryList();
        });
      }).catch(e => {
      });
    },
    deleteImageCategory(imageCategory) {
      this.$confirm('确定删除当前分类吗?').then(confirm => {
        if (confirm !== 'confirm') {
          return;
        }
        api.image_deleteImageCategory({
          id: imageCategory.id
        }).then(res => {
          if (res.data.code !== '000') {
            this.$message.error(res.data.message);
            return;
          }
          this.$message.success('删除成功');
          this.getImageCategoryList();
        })
      });
    }
  },
  mounted() {
    this.getImageCategoryList();
  }
}
</script>

<style scoped>

</style>
